import { render } from "./UiTableScroller.vue?vue&type=template&id=6bf770f3&lang=pug"
import script from "./UiTableScroller.vue?vue&type=script&lang=js"
export * from "./UiTableScroller.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__